import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-vragen-fiscale-eenheid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-vragen-fiscale-eenheid.component.html',
  styleUrl: './tekst-vragen-fiscale-eenheid.component.scss',
})
export class TekstVragenFiscaleEenheidComponent {}
